// extracted by mini-css-extract-plugin
export default {"container":"FeesOverrideTable_container__7d1J4"};